import { Reveal } from "./Reveal";

export const PageHero = ({ eyebrow, title, text }) => (
  <section className="pt-32 sm:pt-40 pb-12 sm:pb-16 bg-cream" data-testid="page-hero">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="eyebrow text-terracottaD">{eyebrow}</p>
      </Reveal>
      <Reveal delay={0.08}>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.08] mt-4 max-w-3xl">{title}</h1>
      </Reveal>
      {text && (
        <Reveal delay={0.16}>
          <p className="text-base sm:text-lg leading-relaxed text-slate2 mt-6 max-w-2xl">{text}</p>
        </Reveal>
      )}
    </div>
  </section>
);
